module.exports = __webpack_public_path__ + "img/video.d9f5c783.jpg";